export const SET_POIS = "pois/SET_POIS";
export const SET_POI = "pois/SET_POI";
